import type { ReactNode } from "react";

const inputClass =
  "rounded-md border border-border bg-surface px-3 py-2.5 text-sm text-text outline-none transition-colors focus:border-primary focus:shadow-[0_0_0_3px_var(--primary-soft)]";

export function fieldInputClass(invalid?: boolean): string {
  return invalid ? `${inputClass} is-invalid` : inputClass;
}

type FieldProps = {
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  className?: string;
  children: ReactNode;
};

/** Layout wrapper: label + control + optional hint/error.
 *  The control inside should use `fieldInputClass()` (or render its own
 *  `:user-invalid`-aware element) so validation feedback styling applies. */
export function Field({ label, required, hint, error, className = "", children }: FieldProps) {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      <label className="text-[13px] font-medium text-text">
        {label}
        {required ? " *" : ""}
      </label>
      {children}
      {error ? (
        <div className="text-[12px] text-danger">{error}</div>
      ) : hint ? (
        <div className="text-[12px] text-text-muted">{hint}</div>
      ) : null}
    </div>
  );
}
